/** Copyright © 2024 Qcells. All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized use,
 * duplication, or distribution of software is strictly prohibited.
 */
import { ROLE_NAME } from '@hems/util/src/constant/role';
import type { RoleNameValue } from '@hems/util/src/constant/role';

import type { i18nTranslation } from 'hems';

import type { ValueType } from 'hems/common/utils';

export const BMS_FLAG_CODE = {
  OFF: '0',
  ON: '1',
} as const;

export type BMSFlagCodeValue = ValueType<typeof BMS_FLAG_CODE>;

export const MIN_MAX_AVG_DATA_LABEL = (t: i18nTranslation) => [t('common.min'), t('common.max'), t('common.avg')];

export const PCSModePermissionRoleName: RoleNameValue[] = [ROLE_NAME.DEV, ROLE_NAME.ADMIN, ROLE_NAME.SERVICE];

/** MQTT Protocol > Monitoring - EnergyControl 옵션 */
export const ENERGY_CONTROL = {
  STAND_BY: '0',
  SELF_CONSUMPTION: '1',
  ZERO_EXPORT: '2',
  TIME_BASED: '3',
  EXTERNAL_GENERATION: '4',
  EOS: '5',
  GATEWAY: '6',
  ENGINEER: '7',
  SMART_SAVING: '8',
  STORM_COVER: '9',
  VPP: '10',
} as const;

export type EnergyControlValue = ValueType<typeof ENERGY_CONTROL>;

export const EMMCLifePermissionRoleName: RoleNameValue[] = [ROLE_NAME.DEV, ROLE_NAME.ADMIN, ROLE_NAME.SERVICE];
